import * as React from "react";
import Box from "@mui/material/Box";
import {Typography, useMediaQuery, useTheme} from "@mui/material";
import {usePageTitle} from "../../../hooks/use_page_title";

export const HeaderTitle = () => {
    const {sectionTitle, pageTitle} = usePageTitle();
    const isSmallScreen = useMediaQuery(useTheme().breakpoints.down('sm'));

    return (
        <Box sx={{flexGrow: 1}}>
            {!isSmallScreen && sectionTitle &&
                <>
                    <Typography component="span" variant="body2" color="inherit" noWrap>
                        {sectionTitle}
                    </Typography>
                    <Typography sx={{
                        paddingLeft: (theme) => theme.spacing(1),
                        paddingRight: (theme) => theme.spacing(1) }
                    } component="span" variant="body2" color="inherit" noWrap>
                        |
                    </Typography>
                </>
            }

            <Typography component="span" variant="h6" color="inherit" noWrap>
                {pageTitle}
            </Typography>
        </Box>
    );
}
